import React from 'react';

const map = {
  'Submitted':      'active',
  'On Track':       'ontrack',
  'Multi-year':     'active',
  'Due':            'pending',
  'Watch':          'pending',
  'Renewal due':    'pending',
  'Overdue':        'overdue',
  'At Risk':        'atrisk',
  'At risk':        'atrisk',
  'Rejected':       'overdue',
  'CSR':            'info',
  'Foundation':     'onhold',
  'PSU Fdn':        'neutral',
  'FCRA':           'gold',
  'New':            'new',
  'Closed':         'closed',
  'Pending Renewal':'pending',
  'Renewing':       'pending',
  'Active':         'active',
};

export function Chip({ children, kind, className = '' }) {
  return (
    <span className={`chip ${map[kind] || kind || 'neutral'} ${className}`}>{children}</span>
  );
}

export function ProgramChip({ program, PROGRAMS }) {
  const p = PROGRAMS[program];
  if (!p) return null;
  return <span className={`chip ${p.cls}`}>{p.name}</span>;
}

export function ProgressBar({ pct, color }) {
  const pctClamped = Math.min(100, Math.max(0, pct));
  return (
    <div className="prog">
      <div className="track">
        <div className="fill" style={{ width: `${pctClamped}%`, background: color }} />
      </div>
      <span className="pct">{pctClamped.toFixed(0)}%</span>
    </div>
  );
}
